import React from 'react';
import ZonesList from './ZonesList';
import ZoneDetailsPanel from './ZoneDetailsPanel';
import ZonesEmptyState from './ZonesEmptyState';
import RecordEditors from './RecordEditors';

interface ZoneContentProps {
  // Zone data
  zones: any[];
  filteredZones: any[];
  selectedZone: any;
  
  // Zone records
  zoneRecords: any[];
  recordsLoading: boolean;
  recordsError: string | null;
  
  // Filter state
  isFiltered: boolean;
  searchTerm: string;
  selectedProvider: string;
  
  // Loading state
  loading: boolean;
  
  // Record editing state
  editingRecord: any;
  showNewRecord: boolean;
  
  // Callbacks
  onZoneClick: (zone: any) => void;
  onAddZone: () => void;
  onClearFilters: () => void;
  onRefreshRecords: (zoneId: string) => Promise<void>;
  onEditRecord: (record: any) => void;
  onDeleteRecord: (recordId: string) => Promise<void>;
  onAddRecord: () => void;
  onBulkDelete: (recordIds: string[]) => Promise<void>;
  onBulkUpdateTTL: (recordIds: string[], ttl: number) => Promise<void>;
  onUpdateRecord: (recordId: string, updateData: any) => Promise<void>;
  onCreateRecord: (recordData: any) => Promise<void>;
  onCancelEdit: () => void;
  onCancelNew: () => void;
}

const ZoneContent: React.FC<ZoneContentProps> = ({
  zones,
  filteredZones,
  selectedZone,
  zoneRecords,
  recordsLoading,
  recordsError,
  isFiltered,
  searchTerm,
  selectedProvider,
  loading,
  editingRecord,
  showNewRecord,
  onZoneClick,
  onAddZone,
  onClearFilters,
  onRefreshRecords,
  onEditRecord,
  onDeleteRecord,
  onAddRecord,
  onBulkDelete,
  onBulkUpdateTTL,
  onUpdateRecord,
  onCreateRecord,
  onCancelEdit,
  onCancelNew,
}) => {
  // Show empty state when no zones match filters
  if (filteredZones.length === 0) {
    return (
      <ZonesEmptyState
        isFiltered={isFiltered}
        onAddZone={onAddZone}
        onClearFilters={onClearFilters}
        searchTerm={searchTerm}
        selectedProvider={selectedProvider}
      />
    );
  }

  return (
    <div>
      {/* Show zones list when no zone is selected */}
      {!selectedZone && (
        <ZonesList 
          zones={filteredZones} 
          onZoneClick={onZoneClick} 
          isLoading={loading} 
        />
      )}

      {/* Show zone details when a zone is selected */}
      {selectedZone && (
        <div className="space-y-4">
          <RecordEditors
            selectedZone={selectedZone}
            editingRecord={editingRecord}
            showNewRecord={showNewRecord}
            onUpdateRecord={onUpdateRecord}
            onCreateRecord={onCreateRecord}
            onCancelEdit={onCancelEdit}
            onCancelNew={onCancelNew}
          />

          <ZoneDetailsPanel
            selectedZone={selectedZone}
            zoneRecords={zoneRecords}
            recordsLoading={recordsLoading}
            recordsError={recordsError}
            onRefreshRecords={onRefreshRecords}
            onEditRecord={onEditRecord}
            onDeleteRecord={onDeleteRecord}
            onAddRecord={onAddRecord}
            onBulkDelete={onBulkDelete}
            onBulkUpdateTTL={onBulkUpdateTTL}
          />
        </div>
      )}
    </div>
  );
};

export default ZoneContent;